const { on } = require('hammerjs');

(function () {
  class SymbolOverlayDisplay extends PIXI.Container {
    constructor() {
      super();
      StateMachine.Create(this);
    }

    initialise() {}

    resetLockedWilds() {}

    hideWildPanels() {}

    showWildPanels() {}

    removeAllLockedWilds() {}

    addLockedWilds(data, callback) {}

    get WildsPresent() {
      return [];
    }

    animateWild() {}

    bringInWild(position) {}

    moveWild(position) {}

    async wildHasLanded(position) {}

    doEndDelay(time) {}

    addBonusOverlays(data) {}

    hideAllBonusOverlays() {}

    dimAllSymbols(showDim, duration) {}

    dimSymbols(symbols, showDim, duration) {}

    dimSymbol(reel, row, showDim, duration) {}

    hideBonusOverlay(reel, row) {}

    showBonusOverlay(reel, row) {}

    onLayoutComplete() {}
  }

  create = function (json) {
    return new SymbolOverlayDisplay();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('symbolOverlayDisplay', create, initialise, getFilesRequired);
})();
